import httpClient, { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'

// sentry
import * as Sentry from '@sentry/vue'

export const apiPostDamage = (sinisterBody) => {
  return httpClient
    .post('damages/', sinisterBody)
    .then((data) => data)
    .catch((error) => {
      // Send sentry custom event
      const scope = new Sentry.Scope()
      // Set tags
      scope.setTag('error.type', 'HttpError')
      scope.setExtra('http.status_code', error.response.status)
      // If status code is 500, set "error" level
      error.response.status >= 500 && error.response.status < 600 ? scope.setLevel('error') : scope.setLevel('warning')
      scope.setTag('section', 'Post Damage')
      scope.setContext({ sinisterBody: sinisterBody })
      Sentry.captureException(
        new Error('Error in post damage call'),
        () => scope
      )

      Promise.reject(error)
    })
}

export const apiPatchDamage = (sinisterBody) => {
  return httpClient
    .post('damages/update', sinisterBody)
    .then((data) => data)
    .catch((error) => {
      // Send sentry custom event
      const scope = new Sentry.Scope()
      // Set tags
      scope.setTag('error.type', 'HttpError')
      scope.setExtra('http.status_code', error.response.status)
      // If status code is 500, set "error" level
      error.response.status >= 500 && error.response.status < 600 ? scope.setLevel('error') : scope.setLevel('warning')
      scope.setTag('section', 'Patch Damage')
      scope.setContext({ sinisterBody: sinisterBody })
      Sentry.captureException(
        new Error('Error in patch damage call'),
        () => scope
      )

      Promise.reject(error)
    })
}

export const apiPatchMultiDamages = (damagedBody) => {
  return httpClient.post('damages/many', damagedBody)
}

export const apiPatchStayDamage = (damagedBody) => {
  return httpClient.post('sinister/sinisterPieces/', damagedBody)
}

export const apiGetDamage = (sinisterId) => {
  const params = new URLSearchParams()
  if (sinisterId) {
    params.set('sinister_id', sinisterId)
  }

  return httpClient
    .get(`damages/resume${paramsToString(params)}`)
    .then((data) => data)
}

export const apiDeleteDamage = (sinisterId, damageId) => {
  const params = new URLSearchParams()
  if (sinisterId) {
    params.set('sinister_id', sinisterId)
  }
  return httpClient
    .post(`damages/${damageId}${paramsToString(params)}`)
    .then((data) => data)
}

export const apiPostDamageUptec = (sinisterBody) => {
  return httpClient
    .post('furniture/upptec/damage', sinisterBody)
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiPostImage = (
  damageId,
  { imageName, imageType, imageContent }
) => {
  const imageData = { imageName, imageType, imageContent }

  return httpClient
    .post(`/damages/${encodeURIComponent(damageId)}/image`, imageData)
    .catch((error) => Promise.reject(error))
}

export const apiGetMobilierDamages = (sinisterId) => {
  const params = new URLSearchParams()
  if (sinisterId) {
    params.set('sinister_id', sinisterId)
  }
  // Temporal endpoint for getting mobilier damages.
  return httpClient
    .get(`claimData${paramsToString(params)}`)
    .then((data) => data)
}

export const sendPhotoclaimDamages = (sinisterId, body) => {
  const params = new URLSearchParams()
  params.set('claimId', sinisterId)

  return billmaHttpClient.post(
    `/machine/api/photoclaim${paramsToString(params)}`,
    body
  )
}
